module.exports = __webpack_public_path__ + "img/mutafannin.1deed05e.jpg";